export enum CommandErrorKind {
  Invariant = 'invariant',
  NotFound = 'not_found',
  Validation = 'validation',
  RollbackFailed = 'rollback_failed',
  Unknown = 'unknown',
}

export type CommandError = {
  kind: CommandErrorKind;
  message: string;
  details?: Record<string, unknown>;
};

export const isCommandError = (error: unknown): error is CommandError => {
  if (!error || typeof error !== 'object') return false;
  return 'kind' in error && 'message' in error;
};
